// extracted by css-extract-rspack-plugin
export default {"cls1":"ActionNav-cls1_T5m","cls2":"ActionNav-cls2_Yno ActionNav-cls1_T5m"};